import { DEFAULT_INDENT_SIZE, depthThresholds, indentSizes } from './constants';
const getIsCorrectIndentSizeValue = (indentSize) => {
    return indentSizes.includes(indentSize);
};
export const normalizeIndentSize = (indentSize) => {
    return getIsCorrectIndentSizeValue(indentSize)
        ? indentSize
        : DEFAULT_INDENT_SIZE;
};
export const getDepthThreshold = (indentSize) => {
    return depthThresholds[indentSize];
};
//# sourceMappingURL=utils.js.map